var $93c080405bcb117f$exports = {};
$93c080405bcb117f$exports = {
  "backButton": args => "\u05D7\u05D6\u05D5\u05E8 \u05D0\u05DC ".concat(args.prevMenuButton),
  "moreActions": "\u05E4\u05E2\u05D5\u05DC\u05D5\u05EA \u05E0\u05D5\u05E1\u05E4\u05D5\u05EA",
  "unavailable": "\u05DC\u05D0 \u05D6\u05DE\u05D9\u05DF, \u05D4\u05E8\u05D7\u05D1 \u05DC\u05E4\u05E8\u05D8\u05D9\u05DD"
};
export { $93c080405bcb117f$exports as default };